import React, { useEffect } from 'react'
import FooterWidgetComponent from '../../../widgets/FooterWidget/FooterWidgetComponent'
import HeaderWidgetComponentTransaparent from '../../../widgets/HeaderWidget/HeaderWidgetComponentTransparent'
import {Route, Link, Routes, useParams} from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { ARTICLE_ONE } from '../../../../../../GraqhQl/Queries';
import HeaderWidgetComponent from '../../../widgets/HeaderWidget/HeaderWidgetComponent';
import { ContainerFluid,Container,HeadingText,Cardde } from './ArticleDetailComponent.style';
import parse from 'html-react-parser';
function ArticleDetailBannerComponent(props) {
  const {id} = useParams();

  return (
    <div>
        <HeaderWidgetComponent />

        {/* <LatestArticleDetailBannerComponentComponent/> */}
        <ArticleDetailBody id={id}/>
        <FooterWidgetComponent/>
    </div>
  )
}



function ArticleDetailBody(props) {
  const id=props.id;
  const { loading, error, data } = useQuery(ARTICLE_ONE,{
    variables:{
      // "articleOneId":"636a6372dfc503a70f3bb50f",
      "articleOneId":id

    }  
  });
     const cardImag = 'https://images.unsplash.com/photo-1657434743750-9f4559cfa57d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2340&q=80';


useEffect(() => {
  console.log("Blog data",data)
  console.log("id ",id)
 }, [id,data])
  if (loading) return  <div ><p className="center">Loading Stories..</p></div>;
  if (error) return <p className="center">Error loading Story!</p>;
  return (
    <ContainerFluid className='mb-50'>
      <Container>
      <div className='row'>
        <div className='col s12 m12 l8'>
            {/* banner secton */}
            <Cardde class="card-image" 
                style={{
                  borderRadius:"10px",
                  backgroundImage:`url(${data.article_one.image})`,
                  backgroundSize:"100% 100%",
                  backgroundRepeat:'no-repeat',
              }}
            >
            </Cardde>
            {/* banner secton */}
           

            {/* Title section */}
            <div className='col s12'>
                <HeadingText>
                  {parse(data.article_one.title)}
                </HeadingText>
            </div>
            <br/>
            <div className="col s12">
              <i className="material-icons " style={{
                fontSize:"12px"
              }}>visibility
                </i>  <span> {data.article_one.views} <b>Views</b></span>
            </div>
            <br/>
            {/* Title section */}

            {/* boddy section */}
            <div className='col s12'>
              {parse(data.article_one.body)}
            </div>

            {/* boddy section */}
            

            
            
          </div>
        <div className='col s12 m12 l4'></div>
      </div>
      </Container>
    </ContainerFluid>
  )
}

export default ArticleDetailBannerComponent;
